<template>
    <div
        id="settings_team_view"
        class="m-auto pt-8"
        width="100%"
    >
        <EspAvatarUploader
            v-if="changeFoto"
            :url="avatarUrl"
            :request="request"
            :rename="rename"
            :contain="false"
            :size="`${imageSize}px`"
            avatarClass="m-auto d-block"
            :maxSize="maxSize"
            :clickable="true"
            @error-size="onErrorSize"
            @error-type="onErrorType"
            @success="success"
            @failed="failed"
        >
            <template #none>
                <v-avatar color="grey" :size="imageSize">
                    <v-icon dark x-large>
                        mdi-camera
                    </v-icon>
                </v-avatar>
            </template>
            <template #loading="{ status }">
                <div class="m-auto" >
                    <v-progress-circular
                        :value="status.progress"
                        :size="100"
                        :width="4"
                        :color="theme.textColor"
                    />
                    <h2 class="pt-3" :style="{'color': theme.textColor}">
                        {{$t('app_task_photo_loading')}}
                    </h2>
                </div>

            </template>
        </EspAvatarUploader>

        <div v-if="changeName" class="m-auto pt-12" :style="`max-width:400px`">
            <v-text-field
                required
                filled
                v-model="teamname"
                :placeholder="$t('welcomeTeamPlaceholder')"
                rounded
                @input="onChangedInput"
                class="settings-view-team"
            ></v-text-field>
        </div>
    </div>
</template>

<script>
import {EventBusNotification} from "../EventBusNotification";
import {imageMixin} from '../../utils/image-mixin';
import {layoutMixin} from "../../utils/layout-mixin";
import Media from "../../api/media.js";
import EspAvatarUploader from "../ui/EspAvatarUploader";

export default {
    mixins:[imageMixin,layoutMixin],
    components: {
        EspAvatarUploader
    },
    props:{
        value:{
            type:Boolean,
            default:false
        },
        changeFoto:{
            type:Boolean,
            default:false
        },
        changeName:{
            type:Boolean,
            default:false
        },
        isMobile:{
            type:Boolean,
            default:false
        },
        maxSize: {
            type: Number,
            default: 20480 // 20 MB
        },
        eventId:{},
        color: {},
        backgroundColor: {},
    },
    data() {
        return {
            filename:null,
            teamname:null,
            teamPhoto:null,
            valid:false,
            colorValue: this.color,
            backgroundColorValue: this.backgroundColor
        }
    },
    watch:{
        value(val){
            this.valid=val;
        }
    },
    computed: {
        imageSize(){
            return this.isMobile?150:200;
        },
        hasTeamPhoto(){
            return !this._.isEmpty(this.teamPhoto);
        },
        avatarUrl () {
            return (this.hasTeamPhoto)?this.filename:null;
        }
    },
    mounted() {
        this.assignPseudoElementStyle();
    },
    methods:{
        onErrorSize(){
            const fileSizeInMb=(this.maxSize/1024);
            EventBusNotification.$emit('notify',this.$t('error_file_to_big',{fileSize:fileSizeInMb}));
            this.resetUpload();
        },
        onErrorType(){
            EventBusNotification.$emit('notify',this.$t('error_file_wrong_type'));
            this.resetUpload();
        },
        onChangedInput(){
            const fotoOk=((this.changeFoto && !this._.isEmpty(this.filename)) || !this.changeFoto);
            const nameOk=((this.changeName && !this._.isEmpty(this.teamname)) || !this.changeName)
            this.valid=fotoOk && nameOk;
            this.emitComplete();
            this.$emit('input',this.valid);
        },
        emitComplete(){
            this.$emit('complete',{
                teamPhoto:this.teamPhoto,
                teamName:this.teamname
            })
        },

        resetUpload(){
            this.filename=null;
            this.teamPhoto=null;
        },
        // Responsible for performing the upload request to your API
        request (form, config) {
            return Media.uploadTeamPhoto(form,config,this.filename,this.eventId);
        },
        rename (file) {
            if(file && file.name){
                const fileSplitted=file.name.split('.');
                const ext = fileSplitted[fileSplitted.length-1];
                const currentTimestamp=new Date().getTime();
                this.filename=`${currentTimestamp}.${ext}`
            }else{
                console.warn('Uploaded image has no name');
                this.filename='unnamed.jpg';
            }
            return this.filename;
        },

        success (response) {
            if(response && response.data ){
                const currentTimestamp=new Date().getTime();
                this.filename=response.data.baseUrl+response.data.url+"?"+currentTimestamp; //thumb
                this.teamPhoto=response.data;
            }
            this.onChangedInput();
        },

        failed () {//error
            EventBusNotification.$emit('notify',this.$t('msgTechnicalError'));
            this.resetUpload();
        },
        assignPseudoElementStyle() {
            this.colorValue = this.theme.textColor;
            this.backgroundColorValue = this.theme.backgroundColor;
            document.documentElement.style.setProperty('--color', this.colorValue);
            document.documentElement.style.setProperty('--background-color', this.backgroundColorValue);
        },
    }
}
</script>

<style lang="scss">
#settings_team_view {
    .settings-view-team .v-input__control > .v-input__slot {
        // background-color: var(--background-color);
        border: 2px solid var(--color);
    }
    .settings-view-team .v-input__control {
        border-bottom-color: var(--color) !important;
        border-left-color: var(--color) !important;
        border-right-color: var(--color) !important;
        border-top-color: var(--color) !important;
    }

    .settings-view-team input::placeholder {
        color: var(--color) !important;
        opacity: 1;
    }

    .custom-label-color .v-label {
        color: var(--color) ;
        opacity: 1;
    }

    .settings-view-team input,
    .custom-label-color input{
        color: var(--color)!important;
        caret-color: var(--color);
    }
}


</style>